import MessagePanelFullpage from "./message-panel-fullpage";

export default MessagePanelFullpage;
